<template>
  <div>
    <router-link
      class="btn btn-sm btn-success"
      :to="{ name: 'compras-ordencompra-nueva', params: {} }"
    >
      <i class="fa fa-pencil"></i>
      Nueva Orden de Compra
    </router-link>

    <button
      class="btn btn-sm btn-success"
      type="button"
      @click="nuevaOrdenCompraModal()"
    >
      Generar desde Cotización <i class="fas fa-copy"></i>
    </button>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="nuevaOrdenCompraModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Escanear barra o colocar numero de cotización
                </h4>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <input
                    type="text"
                    class="form-control"
                    v-model="numero_o_barra"
                    v-on:keyup.enter="buscarCotizacion()"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  @click="buscarCotizacion()"
                  class="btn btn-success btn-md btn-block"
                >
                  Buscar <i class="fas fa-search"></i>
                </button>
              </div>
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Tienda</th>
                    <th>Fecha</th>
                    <th>Proveedor</th>
                    <th>estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="generar_orden_compra(cotizacion)">
                    <td>{{ cotizacion.numero }}</td>
                    <td>{{ cotizacion.tienda }}</td>
                    <td>{{ cotizacion.echa }}</td>
                    <td>
                      {{ cotizacion.proveedor_nombre }} -
                      {{ cotizacion.proveedor_codigo }}
                    </td>
                    <td>{{ cotizacion.estado }}</td>
                    <td class="text-center" v-if='cotizacion.estado  == "A"'>
                      <span class="badge badge-sm badge-success">{{ cotizacion.estado }}</span>
                    </td>
                    <td class="text-center" v-if='cotizacion.estado  == "B"'>
                      <span class="badge badge-sm badge-danger">{{ cotizacion.estado }}</span>
                    </td>
                    <td class="text-center" v-if='cotizacion.estado  == "9"'>
                      <span class="badge badge-sm badge-warning">{{ cotizacion.estado }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import TiendaService from "@/services/catalogos/TiendaService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqCompraService from "@/services/compras/ReqCompraService";
import Notifications from "@/notifications/notifications";
import CotizacionesService from "@/services/compras/CotizacionesService";
import OrdenCompraAddTableComponent from "@/components/compras/ordencompra/OrdenCompraAddTableComponent";
import DynamicService from "../../../services/commons/DynamicService";

export default {
  components: {
    OrdenCompraAddTableComponent,
  },
  data() {
    return {
      cotizacion: "",
      numero_o_barra: "",
      current: {
        id: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],
      data: [],
      productos: [],
      options: [],
    };
  },
  computed: {
    ...mapGetters({
      getReqsComprasCotizar: "reqcompras/reqs_compras_cotizar",
    }),
  },
  mounted() {
    let self = this;
    TiendaService.fetch({
      activa: true,
      quitar_paginacion: true,
    }).then((res) => {
      self.tiendas = res.data;
    });
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
  },
  methods: {
    generar_orden_compra(cotizacion) {
      let self = this;
      Notifications.alert.confirm(
        "Generar orden de compra",
        "Esta seguro(a)",
        "",
        function () {
          CotizacionesService.generar_orden_compra(cotizacion.id)
            .then((response) => {
              Notifications.alert.confirm(
                "Orden de Compra Generada",
                "Ir a la Orden de Compra Generada",
                "",
                function () {
                  $("#nuevaOrdenCompraModal").modal("hide");
                  self.$router.push({
                    name: "compras-ordencompra-editar",
                    params: { id: response.data.orden_compra_e },
                  });
                }
              );
            })
            .catch((error) => {
              Notifications.alert.error(
                "No se ha podido realizar la acción",
                error.response.data.detail
              );
            });
        }
      );
    },
    searchProveedor: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProveedorService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.proveedores = res.data;
        loading(false);
      });
    }, 350),
    onSearchProveedor(search, loading) {
      loading(true);
      this.search(loading, searchProveedor, this);
    },
    buscarCotizacion() {
      let self = this;
      self.cotizacion = "";
      DynamicService.postActionList(
        "compras",
        "cotizacion",
        "obtener_cotizacion_x_barra",
        {
          numero_o_barra: self.numero_o_barra,
        }
      )
        .then((response) => {
          self.cotizacion = response.data;
        })
        .catch((error) => {
          Notifications.toast.error(
            "Buscar cotización",
            error.response.data.detail
          );
        });
    },
    nuevaOrdenCompraModal() {
      let self = this;
      $("#nuevaOrdenCompraModal").modal("show");
    },
  },
};
</script>